<script>
    import { onMount, onDestroy } from "svelte";
    import * as api from "../utiles/api";
    import * as store from "../stores/store";
    import * as Common from "../utiles/common.util";
    import { push } from "svelte-spa-router";
    import { PushNotifications } from "@capacitor/push-notifications";
    import { Capacitor } from "@capacitor/core";
    import { Preferences } from "@capacitor/preferences";
    import { get } from "svelte/store";

    onMount(() => {
        // 로그인 상태 체크
        apiGetStatus();

        loadAccountInfo();
    });

    async function loadAccountInfo() {
        let acc = get(store.accountInfo);

        // 새로고침 등으로 메모리 스토어가 비어있으면 저장된 계정정보로 복원
        if (!acc) {
            const stored = await Common.getStoredAccount();
            if (stored) {
                acc = JSON.parse(stored);
                store.accountInfo.set(acc);
            }
        }
    }

    async function apiGetStatus() {
        if (Capacitor.isNativePlatform()) {
            const permStatus = await PushNotifications.requestPermissions();

            if (permStatus.receive !== "granted") {
                return;
            }
        }

        const token = await Common.getStoredToken();

        if (token) {
            if (location.href.includes("Login")) {
                push("/Home");
            }
        } else {
            if (!location.href.includes("Login")) {
                push("/Login");
            }
        }
    }

    async function logout() {
        try {
            await api.get(`/account/logout`);
        } catch (err) {
            // [디버그 로그] 로직과 무관, 에러 확인용 콘솔 출력 - 필요시 이 라인만 찾아 수정/제거
            console.error("logout api error", err);
        }

        store.accountInfo.set(null);
        store.jwt_token.set(null);

        try {
            await Preferences.clear();
        } catch (err) {
            // [디버그 로그] 로직과 무관, 에러 확인용 콘솔 출력 - 필요시 이 라인만 찾아 수정/제거
            console.error("Preferences clear error", err);
        }

        push("/Login");
    }
</script>

<!-- svelte-ignore a11y-click-events-have-key-events -->
<header class="header">
    <div class="mobile inner">
        <div class="logo-wrap">
            <img
                src="resource/img/img_logo.png"
                class="m-logo"
                on:click={() => {
                    if (window.location.hash === "#/Home") {
                        window.location.reload();
                    } else {
                        push("/Home");
                    }
                }}
                alt="로고"
            />

            <button
                type="button"
                class="header-logout-btn"
                on:click={logout}
                title="로그아웃"
                aria-label="로그아웃"
            >
                <svg
                    width="22"
                    height="22"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2.2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                >
                    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
                    <polyline points="16 17 21 12 16 7" />
                    <line x1="21" y1="12" x2="9" y2="12" />
                </svg>
            </button>
        </div>
    </div>
</header>

<!-- svelte-ignore a11y-click-events-have-key-events -->
<section class="main inner">
    <div class="mobile">
        <div class="cmn-title" style="margin-top: 58px;">
            <p>프라임 A/S 접수</p>
            <p class="cmn-title-gray" style="margin-top: 8px;">
                오신 것을 환영합니다 !
            </p>
        </div>

        <div class="menu-list" style="margin-top: 57px;">
            <div class="menu-wrap" style="margin-right: 12px;">
                <div
                    class="menu-inner"
                    on:click={() => {
                        push("/AsList");
                    }}
                >
                    <div class="icon-box">
                        <svg width="44" height="44" viewBox="0 0 24 24" fill="none" stroke="#60a5fa" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"/>
                            <rect x="8" y="2" width="8" height="4" rx="1" ry="1"/>
                            <path d="M9 12h6"/>
                            <path d="M9 16h6"/>
                        </svg>
                    </div>
                    <p>A/S 접수 내역</p>
                </div>
            </div>
            <div class="menu-wrap">
                <div
                    class="menu-inner"
                    on:click={() => {
                        push("/InspectList");
                    }}
                >
                    <div class="icon-box">
                        <svg width="44" height="44" viewBox="0 0 24 24" fill="none" stroke="#34d399" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
                            <path d="m9 12 2 2 4-4"/>
                        </svg>
                    </div>
                    <p>검사관리</p>
                </div>
            </div>
        </div>
    </div>
</section>

<style>
    .header-logout-btn {
        position: absolute;
        right: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        background: transparent;
        border: none;
        padding: 4px;
        cursor: pointer;
        color: #4A4A4A;
        border-radius: 6px;
        transition: all 0.2s ease;
    }

    .header-logout-btn:hover {
        color: #e11d48;
        background: rgba(225, 29, 72, 0.08);
    }

    .header-logout-btn:active {
        transform: scale(0.95);
    }

    .icon-box {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: 8px;
    }
</style>
